import { IPermissions, PermissionEnum } from "src/context/Auth/interface";
import { lastLevelPermissionsMenuSystemConfigs, lastLevelInternalActionsPermissionsMenu } from "src/context/Auth/permissionsMenu";

const hasPermissions = (permissions: IPermissions[], path: string, admin: boolean, superUser: boolean) => {
	const formatPath = path[0] === "/" ? path.replace(path[0], "") : path;
	return permissions.find((x) => x.path === formatPath && x.permission > 0 && x.contractHasAccess) !== undefined || 
	((admin || superUser) && lastLevelPermissionsMenuSystemConfigs.find((x) => x.efb001Codigo === formatPath && !x.internalAction) !== undefined) ||
	(superUser && lastLevelInternalActionsPermissionsMenu.find((x) => x.efb001Codigo === formatPath) !== undefined);
};

export const hasSpecificPermissions = (permissions: IPermissions[], path: string, adminOrSuperUser: boolean, permission: PermissionEnum) => {
	let formatPath = path.startsWith("/") ? path.replace(path[0], "") : path;
	formatPath = formatPath.endsWith("/") ? formatPath.slice(0, -1) : formatPath;
	return adminOrSuperUser || permissions.find((x) => x.path === formatPath && x.permission > 0 && x.permission <= permission && x.contractHasAccess) !== undefined;
};

export const hasContractPermissions = (permissions: IPermissions[], path: string) => {
	const formatPath = path[0] === "/" ? path.replace(path[0], "") : path;
	return permissions.find((x) => x.path === formatPath && x.contractHasAccess) !== undefined;
};

export default hasPermissions;
